import React, { useState } from 'react'
import { InputGroup, TextArea } from '@blueprintjs/core'
import { axiosGet } from '../../util/api'
import { Toasts } from '../../components/toaster/Toast'
import { Button } from '../../components/ui/button'

export const RecipesTesting = () => {
    const [recipeId, setRecipeId] = useState<string>()
    const [result, setResult] = useState(undefined)
    const [loading, setLoading] = useState(false)

    const get = () => {
        setLoading(true)
        axiosGet('recipes/sync-test/' + recipeId)
            .then((res) => {
                setLoading(false)
                console.log('res is', res)
                if (Object.keys(res.data).length > 0) {
                    setResult(res.data)
                    Toasts.warning('Found ' + Object.keys(res.data).length + ' out of sync items')
                } else {
                    setResult(undefined)
                    Toasts.success('This recipe is in sync')
                }
            })
            .catch((res) => {
                setLoading(false)
            })
    }

    return (
        <div className="m-5">
            <div className="flex flex-col">
                <p>Enter a recipe id and get the results of the sync.</p>
                <p>
                    This action does <i>not</i> do any upserts to correct items that are in sync,
                    nor does it actually run the recipe. It is a read-only call for debug purposes.
                </p>
                <InputGroup
                    className="w-1/3"
                    placeholder="Recipe id"
                    type={'text'}
                    onChange={(e) => setRecipeId(e.target.value)}
                />
                <div className="mt-3">
                    <Button loading={loading} text="Test" intent="primary" onClick={get} />
                </div>
            </div>

            {result && (
                <div className="w-full mt-4">
                    <TextArea
                        className="w-full"
                        rows={30}
                        value={JSON.stringify(result, null, 2)}
                    />
                </div>
            )}
        </div>
    )
}
